import { IMeetingChangeset } from '../abstract-meeting-changeset';
import { IControlMeetingDetailsDTO } from '../../../api/control.dao';
import { IAttendeeDTO, IAttendeeOrganizationDTO } from '../../../api/attendees.dao';
import { EventAttendeeUpdatedEventBody } from '../index';

type AttendeeUpdated = boolean;
export class AttendeeUpdatedChangeset extends IMeetingChangeset<EventAttendeeUpdatedEventBody> {
    public applyChangesToMeeting(meeting: Partial<IControlMeetingDetailsDTO>): Partial<IControlMeetingDetailsDTO> {
        for (const [ orgRole, organizations ] of Object.entries(meeting)) {

            if (!this.organizationRoleList.includes(orgRole)) continue;

            const attendeeUpdated = this.updateAttendeeInOrganizations(organizations as IAttendeeOrganizationDTO[]);

            if (attendeeUpdated) {
                return { [orgRole]: organizations };
            }
        }

        return {};
    }

    public get attendeeId(): number {
        return super.getChangeset().attendeeId;
    }

    public get attendeeFirstName(): string {
        return super.getChangeset().firstName;
    }
    public get attendeeLastName(): string {
        return super.getChangeset().lastName;
    }

    private get organizationRoleList(): string[] {
        return [ 'hosts', 'participants', 'presenters', 'supports', 'registrants' ];
    }

    private updateAttendeeInOrganizations(organizations: IAttendeeOrganizationDTO[]): AttendeeUpdated {
        for (const organization of organizations) {
            const attendeeIndex = organization.attendees.findIndex(attendee => Number(attendee.attendeeId) === this.attendeeId);

            if (attendeeIndex !== -1) {
                this.updateAttendeeData(organization.attendees[attendeeIndex]);
                return true;
            }
        }

        return false;
    }

    private updateAttendeeData(attendee: IAttendeeDTO): void {
        attendee.firstName = this.attendeeFirstName;
        attendee.lastName = this.attendeeLastName;
    }
}
